import { useMagicLink, useSession } from "@otto/plattform";
import styles from "../../../shared/components/shell.module.css";

export function SignIn() {
  const { client } = useSession();
  const { email, setEmail, status, submit, blocked } = useMagicLink(client);

  return (
    <div className={styles.centered}>
      <div className={styles.signInCard}>
        <h1 className={styles.title}>Admin</h1>
        <p className={styles.subtitle}>Interne Verwaltung von „Otto tippt los“.</p>

        {status.kind === "sent" ? (
          <div className={`${styles.notice} ${styles.noticeGood}`}>
            Anmeldelink an {email} geschickt. Nicht da? Im Spam-Ordner nachsehen.
          </div>
        ) : (
          <form onSubmit={submit}>
            {status.kind === "error" && (
              <div className={`${styles.notice} ${styles.noticeError}`}>
                Anmeldung nicht möglich: {status.text}
              </div>
            )}
            <label htmlFor="email">E-Mail-Adresse</label>
            <input
              id="email"
              className={`${styles.field} ${styles.spaced}`}
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className={`${styles.row} ${styles.spaced}`}>
              <button type="submit" className={styles.button} disabled={blocked}>
                {status.kind === "sending" ? "Wird gesendet …" : "Anmeldelink senden"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
